import { NoDataException } from 'src/com/sixdee/crbtportal/utils/exceptions/nodataexistsexception';
import { FlashMessageDto, FlashMessageDtoImpl } from './flashmessagedto';

export class FlashMessageBuilder
{
    constructor(private flashMessageList: any)
    {
        if(flashMessageList.flashDetails === undefined)
        {
            throw new NoDataException("FlashMessage data doesnt exists");
        }
    }

    buildAll(): FlashMessageDto[]
    {
        return this.parseFlashMessageDetailsResponse();
    }
    
    private parseFlashMessageDetailsResponse(): FlashMessageDto[]
    {
        let listOfFlashMessage: FlashMessageDto[] = [];
        
        let flashmessagedto = null;
        this.flashMessageList.flashDetails.forEach((messagesJson: any) =>
        {
            flashmessagedto = new FlashMessageDtoImpl();
            flashmessagedto.setId(messagesJson.flashId);
            flashmessagedto.setStatusMessage(messagesJson.flashMessage);
       
            listOfFlashMessage.push(flashmessagedto);
        });
        return listOfFlashMessage;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagebuilder.ts